import React from "react";
import "./style.css";

const Header = () => {
  return (
    <div className="dashboard-header">
      <h4>Welcome to SGTU Portal</h4>
    </div>
  );
};

export default Header;
